import { curry } from 'ramda';

export const formatRange = curry(([start, end]) => {
  if (start === end) return `${ start }`;
  return `${ start } — ${ end || 'Present' }`;
});



// WEBPACK FOOTER //
// ./src/utils/date.js